import Vue from 'vue';


/**
 * 学習者機能画面サイズutility
 */
export default class UserWindowSizeUtility {




  /**
   * 外部呼出し不可
   */
  private constructor() { }




  /**
   * フォントサイズを取得します
   *
   * @returns
   */
  public static fontSize(): number {
    return 12 * this.ratio();
  }

  /**
   * ペン太さを取得します
   *
   * @returns
   */
  public static penSize(): number {
    return 2 * this.ratio();
  }

  /**
   * ペン太さ（S）を取得します
   *
   * @returns
   */
  public static penSizeS(): number {
    return 1 * this.ratio();
  }

  /**
   * 数値を 基本画面サイズ / 現在画面サイズ の比率で補正します。
   *
   * @param num 数値
   * @returns 補正後数値
   */
  public static calculateRatio(num: number): number {
    return num * this.ratio();
  }

  /**
   * キャンバス用フォント設定文字列を取得します
   *
   * @param fontSize フォントサイズ（指定がない場合はthis.fontSizeを適用）
   * @param ratioFlag 補正フラグ（指定がない場合はサイズ補整を行います）
   * @return キャンバス用フォント設定文字列
   */
  public static canvasFont(fontSize?: number, ratioFlag?: boolean, fontFamily = '"kyokasyo"'): string {
    if (fontSize === undefined) fontSize = this.fontSize();
    else if (ratioFlag === undefined) fontSize *= this.ratio();
    return `normal ${fontSize}px ${fontFamily}`;
  }

  /**
   * キャンバス用確認フォント設定文字列を取得します
   *
   * @return キャンバス用フォント設定文字列
   */
  public static canvasConfirmFont(fontFamily = '"kyokasyo"'): string {
    const fontSize = this.fontSize() * 2;
    return `normal ${fontSize}px ${fontFamily}`;
  }

  /**
   * キャンバス用指数確認フォント設定文字列を取得します
   *
   * @return キャンバス用指数フォント設定文字列
   */
  public static canvasConfirmExponentsFont(): string {
    return `normal ${this.fontSize()}px "kyokasyo"`;
  }




  /**
   * 基本画面サイズ / 現在画面サイズ の比率を取得します。
   *
   * @returns
   */
  private static ratio(): number {
    return Vue.prototype.$_windowSize.ratio;
  }




}
